import React, { useEffect } from 'react';
export function Privacidad() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="legal-page" data-id="element-621" data-mp="3fd08ly8fwqqr">
      <div className="legal-hero" data-id="element-622" data-mp="3fd9yzmxeczwz">
        <p className="legal-overline" data-id="element-623" data-mp="31mwrtmsbxp8p">Transparencia total</p>
        <h1 className="legal-title" data-id="element-624" data-mp="31meqibqt8ktx">Política de privacidad</h1>
        <p className="legal-subtitle" data-id="element-625" data-mp="35n6y70k1aho3">
          SAVIA · Última actualización: junio 2025
        </p>
      </div>
      <div className="legal-body" data-id="element-626" data-mp="2rnpidaopueqv">
        <div className="legal-section" data-id="element-627" data-mp="2rqtseoov44pg">
          <h2 data-id="element-628" data-mp="2wntyv0pmj9h3">1. Quién somos</h2>
          <p data-id="element-629" data-mp="2wp51gx7c2b6m">
            SAVIA es una marca de velas artesanales con sede en Bogotá,
            Colombia. Operamos bajo el sitio web saviacolombia.com y el canal de
            ventas @savia.ritualco en Instagram.
          </p>
          <p data-id="element-630" data-mp="2mr7cg7hngacy">
            Para cualquier consulta relacionada con privacidad y datos, puedes
            escribirnos a través de WhatsApp al +57 321 339 6782.
          </p>
        </div>
        <div className="legal-section" data-id="element-631" data-mp="kvx03u2guzcu">
          <h2 data-id="element-632" data-mp="2jioto4rvo6mo">2. Qué datos recopilamos</h2>
          <p data-id="element-633" data-mp="2jhdteexn5h0b">Al realizar una compra o contactarnos, podemos recopilar:</p>
          <ul data-id="element-634" data-mp="2ej2li9qwpgkq">
            <li data-id="element-635" data-mp="2ejknzo45wr13">Nombre completo</li>
            <li data-id="element-636" data-mp="2t90csyk4ume5">Dirección de envío</li>
            <li data-id="element-637" data-mp="2t7yohse3w3eh">Correo electrónico</li>
            <li data-id="element-638" data-mp="2tb30hbxtc3fp">Número de teléfono / WhatsApp</li>
            <li data-id="element-639" data-mp="2o9ne9gjwfqvq">
              Información de pago (procesada por MercadoPago — no la
              almacenamos)
            </li>
            <li data-id="element-640" data-mp="20kuqi7dfkpc7">Historial de pedidos</li>
          </ul>
        </div>
        <div className="legal-section" data-id="element-641" data-mp="1vm1bubmeqsag">
          <h2 data-id="element-642" data-mp="1vn2ogkj2nmua">3. Para qué usamos tus datos</h2>
          <ul data-id="element-643" data-mp="2aj1t1l6z34uo">
            <li data-id="element-644" data-mp="2aisb8kw30402">Procesar y despachar tu pedido</li>
            <li data-id="element-645" data-mp="2ag5v3wv4kg68">Enviarte actualizaciones sobre tu envío</li>
            <li data-id="element-646" data-mp="25imhmz6947fc">Responder tus consultas</li>
            <li data-id="element-647" data-mp="25ls74fislbbl">Mejorar nuestros productos y servicio</li>
            <li data-id="element-648" data-mp="3lwcmi8572zq1">Enviarte comunicaciones de SAVIA (solo si lo autorizas)</li>
          </ul>
          <p data-id="element-649" data-mp="3gxjayl9gxisi">
            <strong data-id="element-650" data-mp="3gy2qxwfk5x3w">No vendemos ni compartimos</strong> tus datos personales con
            terceros, excepto con los operadores logísticos necesarios para
            realizar el envío.
          </p>
        </div>
        <div className="legal-section" data-id="element-651" data-mp="3sz13lluu4bjm">
          <h2 data-id="element-652" data-mp="1uubim2kyzzf">4. Cookies y datos de navegación</h2>
          <p data-id="element-653" data-mp="1vcdlzbxc8f9">
            Nuestro sitio puede usar cookies técnicas necesarias para el
            funcionamiento de la tienda y cookies analíticas para entender cómo
            los usuarios interactúan con la página.
          </p>
          <p data-id="element-654" data-mp="3aadzb5khfq73">
            Puedes desactivar las cookies desde la configuración de tu navegador
            en cualquier momento.
          </p>
        </div>
        <div className="legal-section" data-id="element-655" data-mp="3f7w9t0e5edh7">
          <h2 data-id="element-656" data-mp="3k077rxpbvp74">5. Almacenamiento y seguridad</h2>
          <p data-id="element-657" data-mp="3k0z6hhe8231m">
            Tus datos se almacenan en la plataforma Shopify, que cumple con los
            estándares internacionales de seguridad PCI DSS. Los pagos son
            procesados por MercadoPago bajo sus propias políticas de seguridad y
            privacidad.
          </p>
        </div>
        <div className="legal-section" data-id="element-658" data-mp="18ngzwdg3rtms">
          <h2 data-id="element-659" data-mp="18mflq03sir0u">6. Tus derechos</h2>
          <p data-id="element-660" data-mp="14mx1l6jsmjz2">
            De acuerdo con la Ley 1581 de 2012 (Protección de Datos Personales —
            Colombia), tienes derecho a:
          </p>
          <ul data-id="element-661" data-mp="zq6nupvgo0gt">
            <li data-id="element-662" data-mp="zpwssnvk7349">Conocer qué datos tenemos sobre ti</li>
            <li data-id="element-663" data-mp="uo7jbcnzixia">Actualizar o corregir tu información</li>
            <li data-id="element-664" data-mp="ppnvt7tqtdnt">Solicitar la eliminación de tus datos</li>
            <li data-id="element-665" data-mp="pr7awv3nxio0">Revocar la autorización para el uso de tus datos</li>
          </ul>
          <p data-id="element-666" data-mp="kye9ag3hqqg5">
            Para ejercer estos derechos escríbenos por WhatsApp al +57 321 339
            6782.
          </p>
        </div>
        <div className="legal-section" data-id="element-667" data-mp="gv82n7cgux95">
          <h2 data-id="element-668" data-mp="bzap18sl8502">7. Menores de edad</h2>
          <p data-id="element-669" data-mp="c0c9g3vhu3ug">
            SAVIA no recopila datos de menores de 18 años. Si eres menor de
            edad, necesitas autorización de un adulto responsable para realizar
            compras.
          </p>
        </div>
        <div className="legal-section" data-id="element-670" data-mp="22o4ym835hz3">
          <h2 data-id="element-671" data-mp="222b86cfyf90v">8. Cambios a esta política</h2>
          <p data-id="element-672" data-mp="224nybcvv8pp0">
            Podemos actualizar esta política ocasionalmente. Cualquier cambio
            significativo será notificado a través de nuestros canales
            oficiales. El uso continuado del sitio implica aceptación de la
            política vigente.
          </p>
        </div>
      </div>
    </div>;
}